




































































import { Component, Vue } from "vue-property-decorator";
import { User } from "@/types";
import axios from "@/plugins/axios";

@Component
export default class Profile extends Vue {
  user = {} as User;
  loading = false;
  color = "primary";

  mounted() {
    this.user = this.$store.state.user;
  }

  get form() {
    return (this.$refs.form as unknown) as {
      reset(): void;
      resetValidation(): void;
      validate(): boolean;
    };
  }

  update() {
    if (this.form.validate()) {
      this.loading = true;
      axios
        .post("/api/user", this.user)
        .then(() => {
          this.loading = false;
          this.color = "success";
        })
        .catch(() => {
          this.loading = false;
          this.color = "danger";
        });
    } else {
      this.color = "danger";
    }
  }

  logout() {
    this.$store.dispatch("Logout");
  }
}
